import * as React from 'react';
import s from './preview-elements.scss';
import { PreviewMode } from './preview-context';
import { Layout, Cell, AddItem, Text, Heading, Box } from '@wix/design-system';
import { composer } from '../../../component-decorators/composer';
import type { TFunction } from 'i18next';
import type { Plan } from '@wix/ambassador-marketplace/types';

export interface IPlansPreivewWrapperProps {
  size?: string;
  plans?: Plan[];
}
export class PlansPreivewWrapper extends React.Component<
  IPlansPreivewWrapperProps,
  any
> {
  render() {
    return (
      <PreviewMode.Consumer>
        {(value) => {
          return value.isPreview && this.hasNoPlans() ? (
            <div>
              <Box direction="vertical">
                <Heading appearance="H2">
                  <TranslatedKey tkey="solution.page.pricingAndPlans" />
                </Heading>
                <Text>
                  <TranslatedKey tkey="solution.page.preview.pricingSubtitle" />
                </Text>
              </Box>
              <Layout>
                {' '}
                <Cell span={6}>
                  <div className={s.pricingCta}>
                    <AddItem
                      onClick={() => this.onClickAddPlan(value.appId)}
                      size="large"
                      theme="filled"
                    >
                      {' '}
                      <TranslatedKey tkey="solution.page.preview.planCtaText" />
                    </AddItem>
                  </div>
                </Cell>
              </Layout>
            </div>
          ) : (
            this.props.children
          );
        }}
      </PreviewMode.Consumer>
    );
  }

  hasNoPlans(): boolean {
    return !(this.props.plans !== undefined && this.props.plans.length > 0);
  }
  onClickAddPlan = (appId) => {
    window.open(
      `https://dev.wix.com/dc3/my-apps/${appId}/market/info/basic-info`,
    );
  };
}

const TranslatedKey = composer()
  .withTranslation()
  .compose(({ t, tkey }: { t?: TFunction; tkey: string }) => t(tkey));
